/**
 * RBAC catalog query hook.
 *
 * The catalog is static-ish per backend build — roles, permissions,
 * and role→permission mapping only change when Go source or SQL
 * seed changes. Cached for the session so the invite dialog opens
 * instantly.
 */

import { useQuery } from "@tanstack/react-query";
import { apiFetch, type ApiError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import { rbacCatalogSchema, type RBACCatalog } from "./rbac-schemas";

export async function fetchRBACCatalog(): Promise<RBACCatalog> {
  const raw = await apiFetch<unknown>("/api/v1/rbac/permissions");
  return rbacCatalogSchema.parse(raw);
}

export function useRBACCatalogQuery() {
  return useQuery<RBACCatalog, ApiError>({
    queryKey: queryKeys.rbacCatalog,
    queryFn: fetchRBACCatalog,
    // Catalog is effectively static between deploys — hold
    // forever during the session so the invite dialog never
    // refetches unless the user hard-refreshes.
    staleTime: Infinity,
    gcTime: Infinity,
  });
}
